// This regex is given by Backend Team
export const PLAYER_REGEX = /^[a-z][a-z0-9]{3,10}[a-z0-9]$/

export const FRONTEND_ERROR_CODES = {
    pleaseTryAgain: 110003,
    tryAgainAfterSomeTime: 110003,
    isRequired: 110055,
    currencyIsRequired: 110013,
    playerIdIsRequired: 110017,
    amountIsRequired: 110037,
    decimalIsTwoDigit: 110042,
    accountHolderNameIsRequired: 110018,
    accountHolderNameShouldBeAlphabetsAndDotsOnly: 110019,
    accountNumberIsRequired: 110015,
    bankNameIsRequired: 110021,
    phoneNumberIsRequired: 110014,
    required: 110004,
    walletAddressIsRequired: 110028,
    networkIsRequired: 110056,
    cryptoWalletAddressIsRequired: 110043,
    inValidWalletAddress: 110029,
    passwordIsRequired: 110012,
    passwordGreaterThan6: 110034,
    passwordNotMatch: 110008,
    bankAccountNumberIsRequired: 110052,
    phoneIsRequired: 110051,
    bankAccountLimitExceeded: 110000,
    pleaseCheckCondition: 110001,
    registrationIsNotAvailable: 110002,
    pleaseTryAgainAfterSometime: 110003,
    bankIsRequired: 110005,
    bankNumberIsRequired: 110006,
    newPasswordRequired: 110007,
    accountNumberShouldContainOnlyNumber: 110016,
    bankNameShouldBeValid: 110058,
    enterYourPreferredPlayerId: 110022,
    min5Length: 110023,
    max12Length: 110024,
    invalid: 110025,
    bankAccountHolderNameIsRequired: 110026,
    cryptoNetworkIsRequired: 110027,
    emailFormatInvalid: 110030,
    birthDateIsRequired: 110031,
    socialMediaIdIsRequired: 110032,
    platformIsRequired: 110033,
    oldPasswordIsRequired: 110035,
    confirmPasswordIsRequired: 110036,
    amountGreaterThanZero: 110038,
    balanceInsufficient: 110039,
    minimumWithdrawIs: 110040,
    maximumWithdrawIs: 110041,
    minDepositIs: 110044,
    maxDepositIs: 110045,
    amountMustBeGreatThan: 110048,
    amountMustBeLessThan: 110049,
    countryIsRequired: 110053,
    phoneNumberFormatInvalid: 110054,
}

export const dummyData = {
    id: 'bf35d794-8999-4434-a7ab-3c392d4ac44f',
    title: {
        'en-US': 'This snippet is not available in the selected language',
        'vi-VN': 'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
        'zh-CN': '此片段不可用选定的语言可用',
        'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
    },
    file: {
        'en-US': '5f7dd696-a148-4261-8215-864083f1a3c3.webp',
        'th-TH': 'c16c4523-4665-4132-b81b-2a504f1c2bb2.jpg',
        'vi-VN': '01465330-c916-45ec-8193-c9e9068d7017.webp',
        'zh-CN': '498ab6d6-9417-44e3-8c01-ecfa28315aff.webp',
    },
    mission_type: 3,
    description: {
        'en-US': 'This snippet is not available in the selected language',
        'vi-VN': 'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
        'zh-CN': '此片段不可用选定的语言可用',
        'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
    },
    timezone: 'Asia/Bangkok',
    start_date: '2025-04-01',
    end_date: '2025-04-06',
    tnc: {
        'en-US': 'This snippet is not available in the selected language',
        'vi-VN': 'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
        'zh-CN': '此片段不可用选定的语言可用',
        'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
    },
    status: 2,
    extra_reward: 100,
    mission_dates: [
        {
            date: '2025-04-01',
            activities: new Array(10).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-02',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-03',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-04',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-05',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-06',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-07',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-08',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-09',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-10',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-11',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-12',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-13',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-14',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-15',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-16',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-17',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-18',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-19',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-20',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-21',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-22',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-23',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-24',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-25',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-26',
            activities: new Array(Math.round(Math.random() * 8) + 1).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-27',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-28',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-29',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
        {
            date: '2025-04-30',
            activities: new Array(Math.round(Math.random() * 2) + 8).fill({
                activity_id: '7',
                name: {
                    'en-US':
                        'This snippet is not available in the selected language',
                    'vi-VN':
                        'Đoạn trích này không có sẵn trong ngôn ngữ đã chọn',
                    'zh-CN': '此片段不可用选定的语言可用',
                    'th-TH': 'ตัวอย่างนี้ไม่สามารถใช้ได้ในภาษาที่เลือก',
                },
                file: 'ca474620-b30c-4c55-83f6-9b07225ee9aa.webp',
                sequence: 1,
                reward_amount: 50,
            }),
        },
    ],
}

export const layoutType = 1
